const TMP_URL = `${process.env.REACT_APP_TMP_ORIGIN_URL}/admin/system-config`

const TmpSysConfigApiUrls = {
    GET: `${TMP_URL}/get`,
    EDIT: `${TMP_URL}/update`,
}

export default TmpSysConfigApiUrls